import React from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

// Components
import LinkedTitle from "../../utils/titles/LinkedTitle";
import Title from "../../utils/titles/Title";
import ReviewersSearch from "./ReviewersSearch";
import AdminReviewersForm from "./AdminReviewersForm";

class AdminReviewersEdit extends React.PureComponent {
	render() {
		return (
			<React.Fragment>
				{this.props.role === 'manager' 
					? <Title>Reviewers</Title>
					: <LinkedTitle link={{ href: "/admin/reviewers/add", title: "Create" }}>
						Edit Reviewers
					</LinkedTitle>
				}	

				<Switch>
					<Route path={"/admin/reviewers"} exact component={ReviewersSearch} />
					<Route path={"/admin/reviewers/edit"} exact component={ReviewersSearch} />
					<Route path={"/admin/reviewers/edit/:id"} component={AdminReviewersForm} />
				</Switch>
			</React.Fragment>
		);
	}
}
const mapStateToProps = state => {
	return {
		role: state.user.admin.user.role
	};
};

export default connect(mapStateToProps)(AdminReviewersEdit);



// WEBPACK FOOTER //
// ./src/components/admin/reviewers/AdminReviewersEdit.js